import { EnergyType } from '@eneco/flows/types';
import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
} from '@monorepo-types/dc';
import { assign, setup } from 'xstate';

import { actors } from './energyChoice.actors';
import { FlowConsumerContextEnergy as FlowContext } from '../../../context';
import { getEnergyTypesFromProductTypes } from '../../../shared/helpers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const energyChoiceTypeMachine: any = setup({
  types: {} as {
    input: {
      businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
      label: DC_Repositories_Base_Enumerations_Label;
    };
    context: {
      businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
      label: DC_Repositories_Base_Enumerations_Label;
      values: FlowContext;
      allowDynamicOrHybridOnly: boolean;
      availableProducts: EnergyType[];
    };
    events:
      | { type: 'FETCH_ENERGY_TYPES'; values: FlowContext }
      | { type: 'done.invoke.getEnergyTypes' }
      | { type: 'RESET_ENERGY_TYPES' };
  },
  actors,
}).createMachine({
  id: 'energyChoiceTypes',
  initial: 'IDLE',
  context: ({ input }) => ({
    businessUnit: input.businessUnit,
    label: input.label,
    values: {} as FlowContext,
    allowDynamicOrHybridOnly: false,
    availableProducts: [] as EnergyType[],
  }),

  states: {
    IDLE: {},
    FETCH: {
      invoke: {
        src: 'getEnergyTypes',
        input: ({ context }) => ({
          businessUnit: context.businessUnit,
          label: context.label,
          values: context.values,
          allowDynamicOrHybridOnly: false,
        }),
        onDone: {
          target: 'SUCCESS',
          actions: assign(({ context, event }) => ({
            ...context,
            availableProducts: getEnergyTypesFromProductTypes(event.output?.commodity ?? []),
          })),
        },
        onError: [
          {
            target: 'ERROR_NOT_FOUND',
            guard: ({ event }) => {
              const error = event.error as { message: string };
              return error.message === 'No products found';
            },
            actions: assign(({ context, event }) => ({
              ...context,
              errorMessage: event.error,
              availableProducts: undefined,
            })),
          },
          {
            target: 'ERROR_NOT_SUPPORTED',
            guard: ({ event }) => {
              const error = event.error as { message: string };
              return error.message === 'No supported products';
            },
            actions: assign(({ context, event }) => ({
              ...context,
              errorMessage: event.error,
              availableProducts: undefined,
            })),
          },
          {
            target: 'ERROR',
            actions: assign(({ context, event }) => ({
              ...context,
              errorMessage: event.error || 'Failed to fetch energy types',
              availableProducts: undefined,
            })),
          },
        ],
      },
    },
    SUCCESS: {},
    ERROR: {},
    ERROR_NOT_FOUND: {},
    ERROR_NOT_SUPPORTED: {},
  },
  on: {
    FETCH_ENERGY_TYPES: {
      target: '.FETCH',
      actions: assign(({ context, event }) => {
        return {
          ...context,
          values: event.values,
        };
      }),
    },
    RESET_ENERGY_TYPES: {
      actions: assign(({ context }) => {
        return {
          ...context,
          availableProducts: [],
          errorMessage: 'Address call failed',
        };
      }),
    },
  },
});
